import { Combobox } from "@insights/ui";

const roles = [
  { value: "owner", label: "Owner" },
  { value: "admin", label: "Admin" },
  { value: "contributor", label: "Contributor" },
  { value: "viewer", label: "Viewer" },
] as const;

type RoleComboboxProps = {
  value: string;
  disabled?: boolean;
  label: string;
  onValueChange: (value: string) => void;
};

export function RoleCombobox({
  value,
  disabled = false,
  label,
  onValueChange,
}: RoleComboboxProps) {
  return (
    <Combobox
      value={value}
      options={roles}
      disabled={disabled}
      label={label}
      onValueChange={onValueChange}
    />
  );
}
